// src/plugins/vuetify.js

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);
Vue.use(VueI18n);

const messages = {
  ja: {
    $vuetify: {
      dataIterator: {
        noResultsText: '検索条件と一致する結果はありません。',
      },
      noDataText: '検索条件と一致する結果はありません。',
    },
  },
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'ja', // set locale
  messages, // set locale messages
});

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: { disable: true },
});
